import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get costCenterReport
export const getCostCenterReport = createAsyncThunk("costCenterReport/getCostCenterReport", async (params, { rejectWithValue }) => {
  try {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    const { data } = await API.getCostCenterReport({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all costCenterReport
export const getAllCostCenterReport = createAsyncThunk("costCenterReport/getAllCostCenterReport", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllCostCenterReport();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("costCenterReport/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("costCenterReport/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "costCenterReport/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageCostCenterReport({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create costCenterReport
export const createCostCenterReport = createAsyncThunk(
  "costCenterReport/createCostCenterReport",
  async (data, { rejectWithValue }) => {
    const { name, costCenterReport } = data;
    try {
      const body = JSON.stringify({ name, costCenterReport });
      const { data } = await API.createCostCenterReport(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
export const updateCostCenterReport = createAsyncThunk(
  "costCenterReport/updateCostCenterReport",
  async (data, { rejectWithValue }) => {
    const { id, values } = data;
    const { name, costCenterReport } = values;
    try {
      const body = JSON.stringify({ name, costCenterReport });
      const { data } = await API.updateCostCenterReport(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk("costCenterReport/handleSearch", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getCostCenterReport({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
